/*
 ** Loading => gentle fade in/out animated shape for loading
 */

const Loading = () => {
	return (
		<div className="loading" aria-label="loading-chargement-en-cours">
			Loading
			<div className="loading"></div>
		</div>
	);
};

export default Loading;
